export function openBase64Pdf(base64String: string): void {
  const cleanedBase64 = base64String.replace(/^data:.*;base64,/, '').replace(/\s/g, '');
  const byteCharacters = atob(cleanedBase64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
}


export function downloadBase64Excel(base64String: string, fileName: string): void {
  const cleanedBase64 = base64String.replace(/^data:.*;base64,/, '').replace(/\s/g, '');

  const byteCharacters = atob(cleanedBase64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.xlsx`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


export function applyRowColor(e: any, colorField: string = 'productTypeColour') {
  if (e.rowType === 'data') {
    const color = e.data?.[colorField];
    e.rowElement.style.backgroundColor = (color && color.trim()) ? color : '#ffffff';
  }
}